// 稽古の「止めて、照らして、教える」仕組み (2026-10-11 から配布版の既定。DEV 限定なのは URL の読み取りと比較版の切り替え入口・game.ts)。
//
// 何のため: ユーザー 10-11 (台帳 combat.md「答えるページ・5」の一言・原文):
//   「ゼンゼロのUIチュートリアルみたいに、今注目してほしいところにフォーカスしながらゲーム内の戦闘にストップをかけながら
//    説明をしていくスタイルのチュートリアルにできるかな？…文字を読まないタイプの人にも１つ１つ最初は時間を止めながら伝える」
//   置き場所 = 亡霊の稽古のガードの次 (旧「パリィを2回」と入れ替え・課題は6のまま)・崩され方 = 三連の斬りをガードで受け続けて3発目で崩れる。
//   調べと理由 = docs/research/2026-10-11-zzz-style-tutorial-feasibility.md
//   全部の課題へ広げた版 (3) の設計 = docs/research/2026-10-11-tut-focus-all-lessons-plan.md (止める場面の表・末尾に作った結果)。
//     10-11 朝の答え tut-focus-how「C 稽古の全部の課題を、止めて照らす型にする」・「全部合計で３回で次の稽古に進むようにして」
//     (= どの課題も、止めて教わる1回は数えず、案内なしで3回できたら次へ。firstCounts=false)・tut-focus-miss「2回続けて弾き損ねたら、もう一度だけ止める」。
//
// 値 (開発版の URL):
//   0 = 'off' = 旧 (カードの稽古・止めない)。10-11 までの配布版。比較用に DEV ?tutFocus=0 で戻す。
//   1 = 'exec' : 課題の並びを「パリィ→ガード→崩されて弾く→突き→掴み→波」にし、3つ目の課題だけ止めて教える。
//                カードは今のまま (旧「パリィの合わせかた」のカードはパリィのカードの続きへ・exec-tut-oldcard の答え A)。
//   2 = 'all'  : 1 に加えて、1つ目のパリィの課題も止めて教える (パリィの2枚のカードは出さない)。
//   3 = 'every': 全部の課題と仕上げを止めて教える。亡霊のカードは1枚も出さない。「崩されて弾く」も3回で次へ。
//      ★10-11 から配布版の既定 (指定なし・知らない値も every)。答えるページ「止める稽古を遊んだ感想」play-ship＝「このまま」
//      (長さ＝ちょうどいい・見た目＝見えた・押す時機＝成功した)。
//
// 止める場面 (どれも最初の1回だけ。2回目からは止めない = 「最初は1つ1つ止める」。表 = FOCUS_STEPS):
//   exec_break   : 崩れた瞬間。主人公と左上の体幹のゲージを照らす。押すと進む (押した入力はゲームへ渡さない)。
//   exec_timing  : 亡霊の決め技 (紫) が当たる直前。亡霊と主人公の手元を照らす。パリィを押すとその押しのまま時間が動き出す
//                  = 押した瞬間が受付の中に入っている (押す時機を体で見せる)。弾き損ねが続いたら (2回) もう一度だけ止める。
//   parry_timing : (2・3) 斬りが当たる直前。同じく、パリィを押すとその押しのまま動き出す。
//   (3 だけ) hud_self・hud_boss (稽古の始まりに画面の見かた)・guard_timing・thrust_evade・counter_timing・grab_evade・
//            zone_walk・finale_red・finale_execute。止める時機の前倒し量は TUT_FOCUS (測った値・tests/tut_focus_every.test.ts が固定)。
//   (3 で、3段目の得が入っている時 = 配布版の既定) combo3_hold: 3段目が当たって体幹の戻りが止まった瞬間 (帯の縁が金に光る)。
//            課題の並びは SHADE_COMBO3_LESSONS (赤黒いオーラの課題を突きの1つにまとめ、空いた所に「3段目」の課題)。
//            10-12 ユーザー (答えるページ・原文)「チュートリアルで説明したほうが良いと思う。赤攻撃２種を１種にして、その分この攻撃についての項目を入れる」。
//            作った物・理由・一言の候補 = docs/research/2026-10-12-tut-combo3-lesson.md。
//            10-12 検収パックの答え (E-1 一言＝案1・E-2 印と刻みは要らない・E-3 位置はそのまま／掴みは外してよい) で配布版の既定へ入れた
//            = docs/research/2026-10-12-combo3-ship-and-tut-assist.md。旧の並び (SHADE_EVERY_LESSONS・掴みあり・3段目なし) は DEV ?combo3rd=off だけが戻す。
//
// 補助案内の間の成功は数えない (10-12 ユーザー「失敗し続けた時に再度案内を出すのはそのまま続けてほしいんだけど、それで成功した扱いにしちゃうと
//   自力でできるようになっていないのに失敗し続けても次の項目に進んじゃうから、補助案内を出してるときは成功扱いにしないで」):
//   補助案内 = 続けて損ねた (rearmAfterMisses 回) ためにもう一度止めた場面 (REARMABLE_STEPS)。止めて教える最初の1回は補助案内ではない
//   (止めて教わる1回は数えず、案内なしで3回できたら次へ = firstCounts=false)。もう一度止めた場面を抜けた技は assistAttack に印を付け、
//   その技の間の成功は課題の成功に数えない (game.ts updateTutorial の ev.assisted)。次の技からは数える = 自力でできた時だけ。
//   2026-10-14 (試遊 next-play-1014 B-3「最初の1回も数えない」): 止めて教える最初の1回の技も数えない (= 案内なしで3回)。前は DEV ?tutAssistFirst=count。
//   数えなかった時の見せ方は B-2「何も出さない（今）」のまま。

import { TUT_SIX, tutSix } from './tut_six'
import type { ActiveHit, Boss, FxEvent, Player, TutorialFocusStepId, TutorialState } from './types'
import type { BossDefinition, TutorialLesson } from './bosses'
import { arenaBoundsFor, executeApproachRangeFor, PLAYER } from './balance'
import { combo3rdLockSec, setPostureHoldLook } from './player_combo3_power'

export type TutFocusMode = 'off' | 'exec' | 'all' | 'every'
let mode: TutFocusMode = 'every'

/** URL の値から切り替える。'0' = off (旧のカードの稽古)・'1' = exec・'2' = all・それ以外 (指定なし・'3'・知らない値) は 'every' (配布版の既定)。 */
export function setTutFocusMode(value: string | null | undefined): TutFocusMode {
  mode = value === '0' ? 'off' : value === '1' ? 'exec' : value === '2' ? 'all' : 'every'
  return mode
}
export function tutFocusMode(): TutFocusMode { return mode }

/** 押して抜ける入力。parry_or_confirm = パリィか決定 / move = 歩き (左右・抜けられる向きだけ)。 */
export type FocusPressKind = 'parry' | 'parry_or_confirm' | 'step' | 'attack' | 'move'
/** 照らす所 (描画が画面の位置へ直す・render.ts tutorialFocusHoles)。 */
export type FocusTargetId =
  | 'hud_self' | 'hud_self_posture' | 'hud_boss' | 'hud_boss_posture'
  | 'boss_body' | 'player_body' | 'player_hand' | 'floor_hazard'
  // 体幹の溝だけをぴったり囲う (3段目の課題だけ・冷たい銀の輪 = 金の帯と色を分ける・10-28)。
  | 'hud_boss_posture_bar'
  // 名前の横の幕の玉 (稽古の最後の致命・src/readability_1104.ts)。
  | 'hud_boss_acts'
/** 一言の札を置く所。top_left = 左上の HUD の下 / center = 二人の上 / above_boss_hud = 下のボスの HUD の上。 */
export type FocusTextPos = 'top_left' | 'center' | 'above_boss_hud'

export type FocusStepSpec = {
  /** 照らす所 (先頭から順に穴を開ける)。 */
  targets: FocusTargetId[]
  /** 一言 (1行・10-11 答え tut-focus-line「1行」)。 */
  line: string
  /** 押すボタンの印 ({parry} 等は input_labels で解決する)。 */
  badge: string
  /** 印の右の小さな言葉。 */
  hint?: string
  textPos: FocusTextPos
  /** 印から線を引く照らし (targets の番号)。無し = 線を引かない。 */
  leaderTo?: number
  press: FocusPressKind
  /** 押しをそのコマのゲームへ渡すか (= 押した瞬間がその操作の始まりになる)。 */
  pass: boolean
  /** 止めてから押しを受け付けるまでの最短 (ms)。止まった瞬間の押しっぱなし・連打で、読む前に進まないように。 */
  minShowMs: number
}

/** 開発版の崩れ説明。配布版の項目・稽古の進行とは独立し、描画だけ同じ型を使う。 */
export const DEV_COLLAPSE_FOCUS = import.meta.env.DEV ? {
  active: false,
  ms: 0,
  spec: {
    targets: ['hud_boss_posture', 'boss_body'],
    line: '相手の体幹が満ちると崩れる。そこへ致命の一撃',
    badge: '{parry}', hint: 'で 次へ',
    textPos: 'center', leaderTo: 0,
    press: 'parry_or_confirm', pass: false, minShowMs: 600,
  } satisfies FocusStepSpec,
} : null

/** 続けて損ねるともう一度止める場面 (canShow が misses を見る物 = 補助案内になりうる場面)。ここ以外は最初の1回しか止めない。
 *  課題の成功に数えない対象はこの場面を「もう一度」抜けた技だけ (assistedByRearm)。 */
export const REARMABLE_STEPS: ReadonlySet<TutorialFocusStepId> = new Set<TutorialFocusStepId>([
  'parry_timing', 'guard_timing', 'exec_timing', 'thrust_evade', 'counter_timing', 'grab_evade', 'zone_walk', 'finale_red',
])

// 最初の1回 (止めて教える1回) も数えないか (2026-10-14 試遊 next-play-1014 B-3「最初の1回も数えない」)。
//   既定 = 数えない (止めて教えた技の間の成功も、課題の成功に数えない = 案内なしで3回)。
//   DEV ?tutAssistFirst=count = 10-12〜10-14 の配布版 (最初の1回は数え、もう一度止めた補助案内だけ数えない)。URL は game.ts の DEV の箱の中だけで読む。
let firstCounts = false
export function setTutAssistFirst(value: string | null | undefined): boolean {
  firstCounts = value === 'count'
  return firstCounts
}

/** いま見せている場面を抜けた技の成功を、課題の成功に数えないか。
 *  既定 (10-14) = 止める場面 (REARMABLE_STEPS) なら最初の1回も補助案内も数えない。
 *  ?tutAssistFirst=count = 最初の1回は数え、続けて損ねてもう一度止めた場面 (補助案内) だけ数えない。 */
export function assistedByRearm(tut: TutorialState, id: TutorialFocusStepId): boolean {
  if (!REARMABLE_STEPS.has(id)) return false
  return !firstCounts || (tut.focusSeen ?? []).includes(id)
}

/** この技の間の成功は、補助案内を受けたので課題の成功に数えない。 */
export function isAssistedAttack(tut: TutorialState | null, boss: Pick<Boss, 'attackCount'>): boolean {
  return !!tut && tut.assistAttack !== undefined && tut.assistAttack === boss.attackCount
}

/** 止める場面の表 (docs/research/2026-10-11-tut-focus-all-lessons-plan.md の表と同じ並び)。描き方は render.ts drawTutorialFocus。 */
export const FOCUS_STEPS: Record<TutorialFocusStepId, FocusStepSpec> = {
  hud_self: { targets: ['hud_self'], line: '左上が、LUNAIREの体力と体幹', badge: '{parry}', hint: 'で 次へ',
    textPos: 'top_left', press: 'parry_or_confirm', pass: false, minShowMs: 600 },
  hud_boss: { targets: ['hud_boss'], line: '下が、相手の体力と体幹', badge: '{parry}', hint: 'で 次へ',
    textPos: 'above_boss_hud', press: 'parry_or_confirm', pass: false, minShowMs: 600 },
  parry_timing: { targets: ['boss_body', 'player_hand'], line: '当たる直前に、パリィ', badge: '{parry}',
    textPos: 'center', leaderTo: 1, press: 'parry', pass: true, minShowMs: 350 },
  guard_timing: { targets: ['boss_body', 'player_hand'], line: '押し続けると、ガード', badge: '{parry}', hint: '押したまま',
    textPos: 'center', leaderTo: 1, press: 'parry', pass: true, minShowMs: 350 },
  exec_break: { targets: ['hud_self_posture', 'player_body'], line: '体幹が溜まりきると、崩れる', badge: '{parry}', hint: 'で 次へ',
    textPos: 'top_left', press: 'parry_or_confirm', pass: false, minShowMs: 600 },
  // 10-11 ユーザー「ちなみに、紫に光る一撃はパリィで”のみ”弾ける」(1・2・3 共通)。
  exec_timing: { targets: ['boss_body', 'player_hand'], line: '紫に光る一撃は、パリィでのみ弾ける', badge: '{parry}',
    textPos: 'center', leaderTo: 1, press: 'parry', pass: true, minShowMs: 350 },
  // 赤い攻撃の呼び名は 10-10 の答え red-attack-name＝「赤黒いオーラ」(台帳 combat.md・負け画面と稽古のカードと同じ)。
  thrust_evade: { targets: ['boss_body', 'player_body'], line: '赤黒いオーラの攻撃は、回避する', badge: '{step}',
    textPos: 'center', leaderTo: 1, press: 'step', pass: true, minShowMs: 350 },
  counter_timing: { targets: ['boss_body', 'player_body'], line: '回避の直後に、回避カウンター', badge: '{attack}',
    textPos: 'center', leaderTo: 0, press: 'attack', pass: true, minShowMs: 250 },
  grab_evade: { targets: ['boss_body', 'player_body'], line: '赤黒いオーラの攻撃は、回避する', badge: '{step}',
    textPos: 'center', leaderTo: 1, press: 'step', pass: true, minShowMs: 350 },
  zone_walk: { targets: ['floor_hazard', 'player_body'], line: '床に広がる波は、歩いて外へ', badge: '{move}', hint: 'で 外へ',
    textPos: 'center', leaderTo: 1, press: 'move', pass: true, minShowMs: 450 },
  finale_red: { targets: ['hud_boss_posture', 'boss_body'], line: 'ゲージが赤く光ったら、パリィで崩れる', badge: '{parry}',
    textPos: 'center', leaderTo: 1, press: 'parry', pass: true, minShowMs: 350 },
  finale_execute: { targets: ['boss_body'], line: '崩れた相手へ、致命の一撃', badge: '{attack}',
    textPos: 'center', leaderTo: 0, press: 'attack', pass: true, minShowMs: 350 },
  // 3段目の得が入っている時 (SHADE_COMBO3_LESSONS・配布版の既定)。もう当たった後に止めるので、押しはゲームへ渡さない (読んで次へ)。
  //   一言の候補3つと点検 = docs/research/2026-10-12-tut-combo3-lesson.md (案1・18字 = 今の一番長い一言と同じ。10-12 の答え E-1 で案1に決まった)。
  //   10-28 作者「体幹ゲージが止まっていることをわかりやすく見せて。色が近すぎるのとうまく囲えていないのが原因」:
  //   照らすのは体幹の帯だけ (亡霊の体の輪は外した・体の輪が目を引き、帯の真鍮の輪は帯の金の枠に紛れていた)。
  //   帯は冷たい銀の霜と先端の留め金で「止まっている」と見せ (src/boss_hud_view.ts)、輪も同じ冷たい銀で溝にぴったり沿わせる。
  //   前の形 = COMBO3_HOLD_GOLD (DEV ?postureHoldLook=gold)。
  combo3_hold: { targets: ['hud_boss_posture_bar'], line: '3段目が当たると、体幹の戻りが止まる', badge: '{parry}', hint: 'で 次へ',
    // 印から帯への線は引かない (札の下から帯まで引くと亡霊の体を縦に横切る・10-12 の撮影で確かめた)。
    textPos: 'center', press: 'parry_or_confirm', pass: false, minShowMs: 600 },
}

/** 3段目の止め方の前の形 (10-12〜10-28 の配布版・真鍮の輪で帯と亡霊の体を照らす)。 */
const COMBO3_HOLD_GOLD: FocusStepSpec = { targets: ['hud_boss_posture', 'boss_body'], line: '3段目が当たると、体幹の戻りが止まる', badge: '{parry}', hint: 'で 次へ',
  textPos: 'center', press: 'parry_or_confirm', pass: false, minShowMs: 600 }
const COMBO3_HOLD_FROST: FocusStepSpec = FOCUS_STEPS.combo3_hold

/** DEV ?postureHoldLook=gold で前の形 (帯の金の縁の光と、稽古の止め方) へ戻す。知らない値・null = 配布版。 */
export function applyPostureHoldLook(value: string | null | undefined): void {
  FOCUS_STEPS.combo3_hold = setPostureHoldLook(value) === 'gold' ? COMBO3_HOLD_GOLD : COMBO3_HOLD_FROST
}

const ALL_STEP_IDS = Object.keys(FOCUS_STEPS) as TutorialFocusStepId[]
const recordOf = <T>(f: (s: FocusStepSpec) => T): Record<TutorialFocusStepId, T> =>
  Object.fromEntries(ALL_STEP_IDS.map((id) => [id, f(FOCUS_STEPS[id])])) as Record<TutorialFocusStepId, T>

export const TUT_FOCUS = {
  /** 弾く場面 (パリィ・決め技・仕上げの赤) で、当たる何 ms 前で止めるか。受付 (押してから 120ms) の真ん中あたりに当たりが来る長さ。 */
  leadMs: 60,
  /** ガードの場面で、当たる何 ms 前で止めるか。受付 (120ms) より前に押すと、受付が明けて押したままのガードで受ける。
   *  測った値 (10-11): 残り 50ms で押すとパリィになる・100ms 以上はガード。余裕をとって 250。 */
  guardLeadMs: 250,
  /** 回避の場面で、当たる何 ms 前で止めるか。回避の無敵 (既定 100ms) の中に当たりの最初の重なりが入る長さ。
   *  測った値 (10-11・突き/掴み・向きなし/離れる/踏み込む): 残り 17〜50ms で押すと見切りが開く・67ms 以上は被弾 (踏み込むだけ 83ms まで)。
   *  1コマ 16.7ms 刻みの真ん中 = 40 (残り 33ms のコマで止まる)。 */
  evadeLeadMs: 40,
  /** 反撃の場面で止めるのに要る、見切りの残り (ms)。測った値: 回避が明けた時の残り 333〜383ms・15コマ (250ms) 遅れても刺さる。 */
  counterMinWindowMs: 150,
  /** 波の場面: 歩いて抜けるのに要る距離が、残りの予告の間に歩ける距離のこの割合以下の向きだけ「抜けられる」とする。 */
  walkSafety: 0.85,
  /** 止めてから押しを受け付けるまでの最短 (ms)。 */
  minShowMs: recordOf((s) => s.minShowMs),
  /** 弾き損ね・避け損ねがこの回数続いたら、その場面でもう一度止める。 */
  rearmAfterMisses: 2,
  /** 暗くなる・照らしの輪が開くまでの時間 (ms・描画)。 */
  fadeMs: 220,
} as const

/** 比較版の課題の並び (6つ・旧「パリィを2回」の場所に「崩されて弾く」)。 */
export const SHADE_FOCUS_LESSONS: TutorialLesson[] = [
  { attackId: 'shadeSlash', goal: 'parry' },
  { attackId: 'shadeSlash', goal: 'guard' },
  { attackId: 'shadeGuardChain', goal: 'exec_parry', count: 2, finisherAttackId: 'shadeExecution' },
  { attackId: 'shadeThrust', goal: 'counter' },
  { attackId: 'shadeGrab', goal: 'counter' },
  { attackId: 'shadeRipple', goal: 'zone_evade' },
]
/** 3 の並び: 1・2 と同じ。「崩されて弾く」も、止めて教わる1回は数えず、案内なしで3回で次へ (他の課題は TUTORIAL.successesPerLesson = 3)。 */
export const SHADE_EVERY_LESSONS: TutorialLesson[] = SHADE_FOCUS_LESSONS.map((l) =>
  l.goal === 'exec_parry' ? { ...l, count: 3 } : l)

/** 3段目の得 (src/player_combo3_power.ts・配布版の既定。DEV ?combo3rd=off で切) が入っている時の並び (3 の上に載る・課題の数は6のまま)。
 *   赤黒いオーラの課題は突きの1つだけ (教える事は「赤黒いオーラの攻撃は、回避する」1つ・反撃は突きの後のまま)。
 *   掴みの課題が抜けた所に「3段目」の課題を、「崩されて弾く」の後・赤黒いオーラの前へ入れる (理由 = docs/research/2026-10-12-tut-combo3-lesson.md)。
 *   相手は斬りだけを出す (弾いた後の隙に3段まで振れる・弾かなくても溜めの間に振れる)。 */
export const SHADE_COMBO3_LESSONS: TutorialLesson[] = [
  { attackId: 'shadeSlash', goal: 'parry' },
  { attackId: 'shadeSlash', goal: 'guard' },
  { attackId: 'shadeGuardChain', goal: 'exec_parry', count: 3, finisherAttackId: 'shadeExecution' },
  { attackId: 'shadeSlash', goal: 'combo3', label: '連撃の3段目' },
  { attackId: 'shadeThrust', goal: 'counter' },
  { attackId: 'shadeRipple', goal: 'zone_evade' },
]

/** このボスの稽古の課題。亡霊は配布版の既定で SHADE_COMBO3_LESSONS を使う。DEV ?tutFocus=0 は旧課題・=1|2 は SHADE_FOCUS_LESSONS・=3 は配布版と同じ (DEV ?combo3rd=off なら SHADE_EVERY_LESSONS)。 */
export function tutorialLessonsFor(def: BossDefinition | undefined): TutorialLesson[] | undefined {
  if (!def) return undefined
  if (mode !== 'off' && def.id === 'nameless-shade' && def.tutorialLessons) {
    if (mode !== 'every') return SHADE_FOCUS_LESSONS
    return combo3rdLockSec() > 0 ? SHADE_COMBO3_LESSONS : SHADE_EVERY_LESSONS
  }
  return def.tutorialLessons
}

/** いまの課題 (仕上げ・稽古の外は undefined)。 */
export function currentLesson(tut: TutorialState | null, lessons: TutorialLesson[] | undefined): TutorialLesson | undefined {
  if (!tut || !lessons) return undefined
  return lessons[tut.lesson]
}

/** 当たるまでの残り (ms)。溜めの途中だけ。 */
function chargeRemainingMs(boss: Boss): number {
  const atk = boss.currentAttack
  if (boss.state !== 'telegraph' || !atk) return Infinity
  return atk.chargeMs - boss.stateElapsed * 1000
}

function seen(tut: TutorialState, id: TutorialFocusStepId): boolean {
  return (tut.focusSeen ?? []).includes(id)
}
function misses(tut: TutorialState, id: TutorialFocusStepId): number {
  return id === 'exec_timing' ? (tut.execMisses ?? 0) : (tut.focusMisses?.[id] ?? 0)
}
/** まだ見せていないか、続けて損ねたのでもう一度見せる時。 */
function canShow(tut: TutorialState, id: TutorialFocusStepId): boolean {
  return !seen(tut, id) || misses(tut, id) >= TUT_FOCUS.rearmAfterMisses
}

/** 止める判断に要る、主人公とボスの外の事情 (game.ts が毎コマ作る・3 だけが使う)。 */
export type FocusContext = {
  /** 仕上げ (全部の課題の後) にいる。 */
  inFinale?: boolean
  /** 相手の体幹のゲージが赤く光っている (次のパリィで崩れる・boss_hud_view.ts breakReadyRatio と同じ閾値)。 */
  bossBreakReady?: boolean
  /** いま回避を押せば出る (回避の連打止めの間でない)。 */
  stepReady?: boolean
  /** 当たりの一覧 (床の波の帯を読む)。 */
  hits?: ActiveHit[]
  /** 歩きの速さ (px/秒)。 */
  walkSpeed?: number
  /** 画面の FX と今の時刻 (3段目の課題だけ: 体幹の戻りを止めた印 posture_hold を読む)。 */
  fx?: readonly FxEvent[]
  time?: number
}

/** 3段目が当たって、体幹の戻りを止めたばかりか (combat.ts が出す posture_hold の印・命中の止まりが明けた最初のコマで true)。
 *   止めている間は時刻が進まないので、印の時刻との差は 0。念のため 0.1 秒までは「ばかり」とみなす。 */
function postureHoldJustStarted(boss: Boss, ctx: FocusContext): boolean {
  if (!ctx.fx || ctx.time === undefined || boss.state === 'staggered' || (boss.postureRegenLockSec ?? 0) <= 0) return false
  const now = ctx.time
  return ctx.fx.some((f) => f.kind === 'posture_hold' && f.act === boss.executesTaken && f.sec > 0
    && now >= f.t - 1e-9 && now - f.t <= 0.1)
}

/** 溜めの中で、届く間合いにいて、立っていて、残りが lead 以下 (同じ技で二度止めない)。 */
function meleeTimingReady(tut: TutorialState, player: Player, boss: Boss, leadMs: number): boolean {
  const atk = boss.currentAttack
  if (!atk || boss.attackCount === tut.focusAttack || player.state !== 'idle') return false
  if (chargeRemainingMs(boss) > leadMs) return false
  // 届かない間合いで止めると、押しても空振りになる (教えたことが嘘になる)。踏み込みの分まで届く時だけ。
  return Math.abs(player.x - boss.x) <= (atk.range ?? 0) + (atk.lungeDistance ?? 0)
}

/** 床の波の帯から、歩いて抜けられる向き (-1 = 左・1 = 右)。帯の外にいる・どちらも間に合わない時は空。 */
export function zoneEscapeDirs(player: Player, hit: ActiveHit, bossId: string, walkSpeed: number): (-1 | 1)[] {
  const half = PLAYER.width / 2
  const inside = player.x + half >= hit.xStart && player.x - half <= hit.xEnd
  if (!inside) return []
  const remainMs = Math.max(0, hit.telegraphMs - hit.elapsedMs)
  const can = walkSpeed * (remainMs / 1000) * TUT_FOCUS.walkSafety
  const walls = arenaBoundsFor(bossId)
  const out: (-1 | 1)[] = []
  // 左へ: 体の右端が帯の左端より左へ出る。右へ: 体の左端が帯の右端より右へ出る。壁の手前で止まるなら抜けられない。
  const leftTarget = hit.xStart - half - 1
  if (player.x - leftTarget <= can && leftTarget >= walls.leftWall) out.push(-1)
  const rightTarget = hit.xEnd + half + 1
  if (rightTarget - player.x <= can && rightTarget <= walls.rightWall) out.push(1)
  return out
}

/** 3 の止める判断。 */
function everyTrigger(tut: TutorialState, lesson: TutorialLesson | undefined, player: Player, boss: Boss, ctx: FocusContext): TutorialFocusStepId | null {
  if (ctx.inFinale) {
    if (boss.state === 'staggered' && player.state === 'idle' && !seen(tut, 'finale_execute')
      && Math.abs(boss.x - player.x) <= executeApproachRangeFor(boss.bodyHalfWidthPx)) return 'finale_execute'
    if (ctx.bossBreakReady && boss.currentAttack?.parryable && canShow(tut, 'finale_red')
      && meleeTimingReady(tut, player, boss, TUT_FOCUS.leadMs)) return 'finale_red'
    return null
  }
  if (!lesson) return null
  if (tut.lesson === 0) {
    if (!seen(tut, 'hud_self')) return 'hud_self'
    if (!seen(tut, 'hud_boss')) return 'hud_boss'
  }
  const atk = boss.currentAttack
  switch (lesson.goal) {
    case 'parry':
      return atk?.parryable && canShow(tut, 'parry_timing') && meleeTimingReady(tut, player, boss, TUT_FOCUS.leadMs) ? 'parry_timing' : null
    case 'guard':
      return atk?.parryable && canShow(tut, 'guard_timing') && meleeTimingReady(tut, player, boss, TUT_FOCUS.guardLeadMs) ? 'guard_timing' : null
    case 'counter': {
      const evadeId: TutorialFocusStepId = lesson.attackId === 'shadeGrab' ? 'grab_evade' : 'thrust_evade'
      // 反撃は突きの課題だけで止める (表のとおり・掴みは回避だけ)。回避が明けて立った最初のコマ・見切りが残っている・届く間合い。
      if (evadeId === 'thrust_evade' && player.state === 'idle' && player.counterWindow * 1000 >= TUT_FOCUS.counterMinWindowMs
        && Math.abs(boss.x - player.x) <= PLAYER.counterThrustRange && canShow(tut, 'counter_timing')) return 'counter_timing'
      if (atk && atk.parryable === false && ctx.stepReady !== false && canShow(tut, evadeId)
        && meleeTimingReady(tut, player, boss, TUT_FOCUS.evadeLeadMs)) return evadeId
      return null
    }
    case 'zone_evade': {
      if (!canShow(tut, 'zone_walk') || boss.attackCount === tut.focusAttack || player.state !== 'idle') return null
      const hit = ctx.hits?.find((h) => h.attackId === lesson.attackId && h.follow === undefined && h.elapsedMs < h.telegraphMs)
      if (!hit) return null
      const walk = ctx.walkSpeed ?? PLAYER.moveSpeed
      // 稽古の6点の比較版 ③ (DEV ?tut6): 予告が少し進んで、床に波が見えてから止める。
      //   待つと抜けられなくなる時は、抜けられる最後の頃 (TUT_SIX.zoneLeadMs 先でもう抜けられない時) に止める。
      if (tutSix(3) && hit.elapsedMs < hit.telegraphMs * TUT_SIX.zoneShowAfter
        && zoneEscapeDirs(player, { ...hit, elapsedMs: hit.elapsedMs + TUT_SIX.zoneLeadMs }, boss.id, walk).length > 0) return null
      return zoneEscapeDirs(player, hit, boss.id, walk).length > 0 ? 'zone_walk' : null
    }
    case 'combo3':
      // 3段目が当たって帯の縁が金に光った瞬間 (最初の1回だけ・弾き損ねのような「損ね」は無いので、もう一度は止めない)。
      return !seen(tut, 'combo3_hold') && postureHoldJustStarted(boss, ctx) ? 'combo3_hold' : null
    default:
      return null
  }
}

/** いま止める場面か (止まっていない時に毎コマ見る)。止めないなら null。 */
export function focusTrigger(tut: TutorialState, lesson: TutorialLesson | undefined, player: Player, boss: Boss,
  ctx: FocusContext = {}): TutorialFocusStepId | null {
  if (mode === 'off' || tut.focus || tut.focusSkipped) return null
  if (lesson?.goal === 'exec_parry') {
    if (player.state === 'stunned' && !seen(tut, 'exec_break')) return 'exec_break'
    const atk = boss.currentAttack
    if (player.state === 'stunned' && atk?.bossFinisher && boss.attackCount !== tut.focusAttack
      && chargeRemainingMs(boss) <= TUT_FOCUS.leadMs
      && (!seen(tut, 'exec_timing') || (tut.execMisses ?? 0) >= TUT_FOCUS.rearmAfterMisses)) return 'exec_timing'
    return null
  }
  if (mode === 'every') return everyTrigger(tut, lesson, player, boss, ctx)
  if (!lesson) return null
  if (lesson.goal === 'parry' && mode === 'all') {
    const atk = boss.currentAttack
    if (atk?.parryable && !seen(tut, 'parry_timing') && meleeTimingReady(tut, player, boss, TUT_FOCUS.leadMs)) return 'parry_timing'
  }
  return null
}

/** 止めた場面を押して抜ける時、その押しをゲームへ渡すか (= 押した瞬間が受付の始まりになる)。 */
export function focusPassesPress(id: TutorialFocusStepId): boolean {
  return FOCUS_STEPS[id].pass
}

export type FocusPress = { parry: boolean; confirm: boolean; step?: boolean; attack?: boolean; moveX?: number }

export type FocusStep =
  | { kind: 'none' }
  | { kind: 'hold'; tutorial: TutorialState }
  | { kind: 'release'; tutorial: TutorialState; passPress: boolean }

/** 止める時に覚えておく事柄 (波の場面の抜けられる向き)。 */
function focusExtras(id: TutorialFocusStepId, lesson: TutorialLesson | undefined, player: Player, boss: Boss, ctx: FocusContext): { dirs?: (-1 | 1)[] } {
  if (id !== 'zone_walk' || !lesson) return {}
  const hit = ctx.hits?.find((h) => h.attackId === lesson.attackId && h.follow === undefined && h.elapsedMs < h.telegraphMs)
  return hit ? { dirs: zoneEscapeDirs(player, hit, boss.id, ctx.walkSpeed ?? PLAYER.moveSpeed) } : {}
}

function pressMatches(kind: FocusPressKind, press: FocusPress, dirs: (-1 | 1)[] | undefined): boolean {
  switch (kind) {
    case 'parry': return press.parry
    case 'parry_or_confirm': return press.parry || press.confirm
    case 'step': return !!press.step
    case 'attack': return !!press.attack
    case 'move': {
      const d = Math.sign(press.moveX ?? 0)
      return d !== 0 && (dirs ?? [-1, 1]).includes(d as -1 | 1)
    }
  }
}

/** 抜けた時に「同じ技の溜めの中でもう一度止まらない」印を付ける場面 (当たる直前で止める物と波)。 */
const MARKS_ATTACK: ReadonlySet<TutorialFocusStepId> = new Set<TutorialFocusStepId>([
  'parry_timing', 'guard_timing', 'exec_timing', 'thrust_evade', 'grab_evade', 'zone_walk', 'finale_red',
])

/** 止める・止め続ける・抜ける を1コマぶん決める (game.ts が毎コマ呼ぶ・純関数)。dtMs = 1コマの長さ。 */
export function stepTutorialFocus(tut: TutorialState, lesson: TutorialLesson | undefined, player: Player, boss: Boss,
  press: FocusPress, dtMs: number, ctx: FocusContext = {}): FocusStep {
  if (mode === 'off') return { kind: 'none' }
  if (!tut.focus) {
    const id = focusTrigger(tut, lesson, player, boss, ctx)
    if (!id) return { kind: 'none' }
    return { kind: 'hold', tutorial: { ...tut, focus: { id, ms: 0, ...focusExtras(id, lesson, player, boss, ctx) } } }
  }
  const { id, ms } = tut.focus
  const spec = FOCUS_STEPS[id]
  const ready = ms >= spec.minShowMs
  if (ready && pressMatches(spec.press, press, tut.focus.dirs)) {
    const focusSeen = seen(tut, id) ? tut.focusSeen! : [...(tut.focusSeen ?? []), id]
    const released: TutorialState = {
      ...tut, focus: null, focusSeen,
      // 同じ技の溜めの中で、もう一度止まらない印。
      focusAttack: MARKS_ATTACK.has(id) ? boss.attackCount : tut.focusAttack,
      // 止めて教えた場面を抜けた技は、成功に数えない印を付ける (10-12 ユーザー・10-14 から最初の1回も)。
      assistAttack: assistedByRearm(tut, id) ? boss.attackCount : tut.assistAttack,
      execMisses: id === 'exec_timing' ? 0 : tut.execMisses,
      ...(tut.focusMisses?.[id] ? { focusMisses: { ...tut.focusMisses, [id]: 0 } } : null),
    }
    return { kind: 'release', tutorial: released, passPress: spec.pass }
  }
  return { kind: 'hold', tutorial: { ...tut, focus: { ...tut.focus, ms: ms + dtMs } } }
}

/** 1コマの戦闘の結果 (game.ts が updateTutorial の後に渡す)。 */
export type FocusOutcome = {
  hitPlayer: boolean
  parried: boolean
  guarded: boolean
  dodged: boolean
  countered: boolean
  /** 見切りの窓が、反撃を当てないまま閉じた。 */
  counterExpired: boolean
  bossStaggered: boolean
  execParried: boolean
}

/** 3 だけ: 弾き損ね・避け損ねを「続けて」数える (成功で 0 に戻す)。2回続いたら、その場面でもう一度止める (canShow)。 */
export function tallyFocusOutcome(tut: TutorialState, lesson: TutorialLesson | undefined, inFinale: boolean, ev: FocusOutcome): TutorialState {
  if (mode !== 'every') return tut
  const m: Partial<Record<TutorialFocusStepId, number>> = { ...(tut.focusMisses ?? {}) }
  const bump = (id: TutorialFocusStepId, miss: boolean, ok: boolean) => {
    if (ok) m[id] = 0
    else if (miss) m[id] = (m[id] ?? 0) + 1
  }
  let execMisses = tut.execMisses
  if (inFinale) bump('finale_red', ev.hitPlayer, ev.bossStaggered)
  else if (lesson?.goal === 'parry') bump('parry_timing', ev.hitPlayer, ev.parried)
  else if (lesson?.goal === 'guard') bump('guard_timing', ev.hitPlayer, ev.guarded)
  else if (lesson?.goal === 'exec_parry') { if (ev.execParried) execMisses = 0 }
  else if (lesson?.goal === 'counter') {
    bump(lesson.attackId === 'shadeGrab' ? 'grab_evade' : 'thrust_evade', ev.hitPlayer, ev.dodged)
    if (lesson.attackId !== 'shadeGrab') bump('counter_timing', ev.counterExpired, ev.countered)
  } else if (lesson?.goal === 'zone_evade') bump('zone_walk', ev.hitPlayer, false)
  const same = Object.keys(m).length === Object.keys(tut.focusMisses ?? {}).length
    && Object.entries(m).every(([k, v]) => tut.focusMisses?.[k as TutorialFocusStepId] === v)
  if (same && execMisses === tut.execMisses) return tut
  return { ...tut, focusMisses: m, execMisses }
}

/** 画面に出す言葉と押すボタン (描画・{parry} 等は input_labels で解決する)。FOCUS_STEPS から引く (旧の名前のまま残す)。 */
export const FOCUS_TEXT: Record<TutorialFocusStepId, { line: string; badge: string; hint?: string }> =
  recordOf((s) => ({ line: s.line, badge: s.badge, hint: s.hint }))
